// extracted by mini-css-extract-plugin
module.exports = {"YXHContractCheck":"index-module_YXHContractCheck_1McNx","title":"index-module_title_2a8y0","idCard":"index-module_idCard_21B24"};